export const login = {
  cloudManagementSystem: "Cloud Management Service",
  signUpToday: "Sign Up Today!",
  companyName: "Company Name",
  forgotPassword: "Forgot password?",
  doNotHaveAnAccount: "Don’t Have an Account?",
  digitizeInspectionReports: "Digitize Inspection Reports",
  assetTrackingUtilizationReports: "Asset Tracking & Utilization Reports",
  unlimitedVideoUploads: "Unlimited Video Uploading",
  privacyPolicy: "Privacy Policy",
  VIAWorkXConnect: "VIA CWorkX Connect",
  loginToWorkXConnectCloud: "Sign in to CWorkX Connect Cloud",
  phoneNumber: "@:common.user.phoneNumber",
  password: "Password",
  signIn: "Sign In",
  noUserCompanyTip: "{email} not found.",
  pleaseInputYourPhoneNumber: "Please input your Phone Number",
  pleaseInputYourPassword: "Please input your password",
  failedToSignIn: "Failed to sign in",
  failedToSignInPleaseRetry: "Failed to sign in. Please retry.",
  userSignIn: "Sign In",
  userEmailNotActivatedTips:
    "Please click the link in the notification email to activate your account.",
  digitizeReports: "Digitalize Reports",
  boostOperationalEfficiency: "Boost Operational Efficiency",
  assetsTrackingAndUtilizationReports: "Assets Tracking & Utilization Reports",
  easyToGetStarted: "Easy to Get Started",
  loginToVIAWorkXConnect: "VIA CWorkX Connect",
  miniProgram: "- VIA Vehicle Manager WeChat Mini Program​​ -",
};
